/* eslint-disable @typescript-eslint/no-var-requires */

import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export interface PromoUnitTemplate {
    heading: string;
    subheading: string;
    link: string;
    svg: SafeHtml;
}

@Component({
    standalone: true,
    selector: 'global-home-promo-card',
    templateUrl: './promo-card.component.html',
    styleUrls: ['../../styles.scss', './promo-card.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    imports: [CommonModule],
})
export class PromoCardComponent {
    viewBrandwatchAcademy: PromoUnitTemplate = {
        heading: 'Brandwatch Academy',
        subheading: 'Improve your skills with on-demand training courses',
        link: 'https://academy.brandwatch.com/#introducing',
        svg: this.domSanitizer.bypassSecurityTrustHtml(
            (require('!!raw-loader?!../..//assets/icons/promo/home-bw-academy.svg') as { default: string }).default
        ),
    };

    constructor(private domSanitizer: DomSanitizer) {}

    get template(): PromoUnitTemplate {
        return this.viewBrandwatchAcademy;
    }
}
